<div class="card-body">
    <div id="apex-basic-radar-chart"></div>
</div>